import styled from "react-emotion"
import PropTypes from "prop-types"
import { injectGlobal } from "react-emotion"

const HeaderItem = styled("p")`
    font-family: ${props => props.theme.fontFamily};
    font-size: ${props => props.theme[props.size || "fontM"]};
    padding: ${props => props.theme[props.padding || "small"]} 0px;
    color: ${props => props.theme.fontColor};
    ${props =>
        props.inline &&
        `
        display: inline-block;
    `};
    ${props =>
        props.light &&
        `
        color: ${props.theme.lightFontColor};
    `};
    ${props =>
        props.align === "left" &&
        `
        margin-right: auto;
        margin-left: 15px;
    `};

    ${props =>
        props.align === "right" &&
        `
        margin-left: auto;
        margin-right: 15px;
    `};

    ${props =>
        props.strong &&
        `
        font-weight: bold;
        color:white;
    `};


    a:link, a:visited, a:hover { color: ${props => props.light ? "#424559" : props.theme.lightFontColor}; font-weight:bold; }
    a:visited { color: ${props => props.light ? "#424559" : props.theme.lightFontColor} }
    a:hover { color: ${props => props.light ? "#424559" : props.theme.lightFontColor} }
`
injectGlobal`
  a > ${HeaderItem} {
    color: black;
  }
`

HeaderItem.propTypes = {
    padding: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge", "none"]),
    margin: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge", "none"]),
    size: PropTypes.oneOf(["fontS", "fontM", "fontL", "fontXL"]),
    align: PropTypes.oneOf(["left", "right"]),
    strong: PropTypes.bool,
    inline: PropTypes.bool,
    light: PropTypes.bool,
}

HeaderItem.displayName = "HeaderItem"
export default HeaderItem



// WEBPACK FOOTER //
// ./src/ui/components/HeaderItem.js